import { getColor } from "../typography/shared.js";
import { Anchor } from "@mantine/core";
import { forwardRef, useCallback } from "react";
import { jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";

//#region src/components/anchor/Anchor.tsx
const Anchor$1 = forwardRef(({ children, color, disabled = false, display, inherit, inline, height, href, lineClamp, onClick, size, target, textDecoration, truncate, width, highContrast = false, bold, textAlign, "aria-label": ariaLabel, "data-testid": testId }, ref) => {
	const handleClick = useCallback((e) => {
		e.stopPropagation();
		onClick?.(e);
	}, [onClick]);
	const isInteractive = !disabled && Boolean(href || onClick);
	const sharedProps = {
		display,
		h: height,
		inherit,
		inline,
		lineClamp,
		onClick: disabled ? void 0 : handleClick,
		size,
		target,
		truncate,
		td: textDecoration ?? (href || onClick ? "underline" : "none"),
		w: width,
		fw: bold ? 600 : 400,
		ta: textAlign,
		style: {
			color: color && getColor(color, highContrast),
			cursor: isInteractive ? "pointer" : "default",
			opacity: disabled ? .5 : void 0
		},
		"aria-disabled": disabled || void 0,
		"aria-label": ariaLabel,
		"data-testid": testId
	};
	if (href && !disabled) return /* @__PURE__ */ jsx(Anchor, {
		...sharedProps,
		component: Link,
		to: href,
		ref,
		children
	});
	const otherProps = onClick ? {
		component: "button",
		type: "button",
		disabled,
		ref
	} : {
		component: "span",
		ref
	};
	return /* @__PURE__ */ jsx(Anchor, {
		...sharedProps,
		...otherProps,
		children
	});
});
Anchor$1.displayName = "Anchor";

//#endregion
export { Anchor$1 as Anchor };